import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CompatibilityCheckResult, CompatibilityCheckFields, FieldResult } from '../types/compatibility-check';
import { ClientService } from '../../../../services/client.service';
import { PusherService } from '@rubii/frontend-common';

@Component({
  selector: 'app-summary',
  templateUrl: './summary.component.html',
  styleUrls: ['./summary.component.scss']
})
export class SummaryComponent implements OnInit, OnDestroy {

  clientId = '';
  result: CompatibilityCheckResult | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private client: ClientService,
    private pusher: PusherService,
    private cdRef: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    const uuid = this.route.snapshot.paramMap.get('uuid');
    if (!uuid) {
      this.router.navigate(['/datasources/custom/upload']);
      return;
    }
    this.clientId = uuid;

    this.sendClientIdToEmerald();

    const stored = sessionStorage.getItem('data-source-custom-file-analyse-result-' + this.clientId);
    if (stored) {
      try {
        this.result = JSON.parse(stored);
      } catch {
        this.router.navigate(['/datasources/custom/upload']);
      }
    } else {
      this.client.agent.getAnswer(this.clientId, 'datasource/media-file-import/compatibility-check').then(res => {
        try {
          this.result = JSON.parse(res.content);
        } catch {
          this.router.navigate(['/datasources/custom/upload']);
        }
      }).catch(() => {
        this.router.navigate(['/datasources/custom/upload']);
      });
    }

    this.pusher.bind(this.clientId, 'json-result', (event: { skill?: string; data?: CompatibilityCheckResult }) => {
      if (event.skill === 'datasource/media-file-import/compatibility-check' && event.data) {
        this.result = event.data;
        sessionStorage.setItem('data-source-custom-file-analyse-result-' + this.clientId, JSON.stringify(event.data));
        this.cdRef.detectChanges();
      }
    });
  }

  ngOnDestroy(): void {
    this.pusher.unbind(this.clientId);
  }

  private sendClientIdToEmerald(): void {
    const w = window as unknown as Record<string, { setClientId: (id: string) => void }>;
    w['__emerald']?.setClientId(this.clientId);
  }

  get fields(): CompatibilityCheckFields | null {
    return this.result?.fields || null;
  }

  get mandatoryEntries(): Array<{ name: string; value: FieldResult }> {
    if (!this.fields?.mandatory) return [];
    return Object.entries(this.fields.mandatory).map(([name, value]) => ({ name, value }));
  }

  get missingMandatory(): Array<{ name: string; value: FieldResult }> {
    return this.mandatoryEntries.filter(e => !e.value.exist);
  }

  get allMandatoryPresent(): boolean {
    return this.mandatoryEntries.length > 0 && this.missingMandatory.length === 0;
  }

  get preferredEntries(): Array<{ name: string; value: FieldResult }> {
    if (!this.fields?.preferred) return [];
    return Object.entries(this.fields.preferred).map(([name, value]) => ({ name, value }));
  }

  get missingPreferred(): Array<{ name: string; value: FieldResult }> {
    return this.preferredEntries.filter(e => !e.value.exist);
  }

  get discardEntries(): Array<{ name: string; value: FieldResult }> {
    if (!this.fields?.discard) return [];
    return Object.entries(this.fields.discard)
      .filter(([, value]) => value.exist)
      .map(([name, value]) => ({ name, value }));
  }

  goBack(): void {
    this.router.navigate(['/datasources/custom/upload']);
  }

  proceed(): void {
    this.router.navigate(['/datasources/custom/generate-mapping', this.clientId]);
  }
}
